// constants.js

export const objectiveData = [
  { id: '1', text: 'WebsiteTraffic' },
  { id: '2', text: 'Branding & Reach' },
  { id: '3', text: 'Conversions / Lead Generation' },
]

export const businessTypeData = [
  { id: '1', text: 'Business1' },
  { id: '2', text: 'Business2' },
  { id: '3', text: 'Business3' },
]

export const formFields = {
  name: {
    key: 'name',
    type: 'text',
    label: 'Campaign Name',
    // required: false,
    // placeholder: 'Enter Name',
    requiredMessage: 'This field is required.',
    displayLayout: 'col-md-12',
    tooltip: '<div> Name </div>',
    maxLength: 100,
    maxLengthMessage: 'maximum 100 characters allowed.',
  },
  biddingStrategy: {
    key: 'biddingStrategy',
    label: 'Bidding Strategy',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'value',
  },


  pacing: {
    key: 'pacing',
    label: 'Pacing',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },

  objective: {
    key: 'objective',
    // label: 'Objective / Goal ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'name',
  },

  gender: {
    key: 'gender',
    label: 'Gender',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'value',
  },

  device: {
    key: 'device',
    label: 'Device',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'value',
  },

  language: {
    key: 'language',
    label: 'Language ',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'value',
  },

  startDate: {
    key: 'startDate',
    label: 'Start Date',
    required: true,
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },
  endDate: {
    key: 'endDate',
    label: 'End Date',
    // label: 'End Date',
    required: true,
    // required: false,
    // placeholder: 'End Date',
    placeholder: 'DD/MM/YYYY',
    displayLayout: 'col-sm-12',
    requiredMessage: 'This field is required.',
  },
  onScreenFb: {
    key: 'onScreenFb',
    // label: 'On Screen Position Details for Facebook',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'value',
    textKey: 'label',
  },
  onScreenIon: {
    key: 'onScreenIon',
    // label: 'On Screen Position Details for Facebook',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'value',
    textKey: 'label',
  },
  accountSeat: {
    key: 'accountSeat',
    label: 'Choose Seat',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    labelLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'value',
    textKey: 'label',
  },


  businessSubCategory: {
    key: 'businessSubCategory',
    label: 'Choose Page',
    placeholder: '--Select--',
    displayLayout: 'col-sm-12',
    labelLayout: 'col-sm-12',
    required: true,
    requiredMessage: 'This field is required.',
    valueKey: 'id',
    textKey: 'value',
  },

};
